import type { NotificationListResponseNotificationsItemBasicInfo } from './notificationListResponseNotificationsItemBasicInfo';
import type { NotificationListResponseNotificationsItemData } from './notificationListResponseNotificationsItemData';
import type { NotificationListResponseNotificationsItemSource } from './notificationListResponseNotificationsItemSource';
import type { NotificationListResponseNotificationsItemStatus } from './notificationListResponseNotificationsItemStatus';
import type { NotificationListResponseNotificationsItemTarget } from './notificationListResponseNotificationsItemTarget';

export type NotificationListResponseNotificationsItem = {
  basicInfo: NotificationListResponseNotificationsItemBasicInfo;
  /** @nullable */
  data?: NotificationListResponseNotificationsItemData;
  source?: NotificationListResponseNotificationsItemSource;
  status: NotificationListResponseNotificationsItemStatus;
  target?: NotificationListResponseNotificationsItemTarget;
};
